import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { BaseService, ConfigService, LoggingService, UtilsMisc, UtilsString, retryWithDelay, ErrorTimeout, ErrorHttp, ErrorUnknown } from '@pit/core';
import { ICronDataService } from '../interfaces/cron.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class CronDataService extends BaseService implements ICronDataService {

  constructor(private http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(configService, loggingService);
  }

  public forceArchiveBuild$(): Observable<boolean> {
    const body: any = {
      authenticationUserName: this.configurationService.configAuth.authUserName,
      authenticationPassword: this.configurationService.configAuth.authPassword
    };
    return this.httpPost(this.getUrl('admin/archive/build'), body)
      .pipe(map((json: boolean) => {
        return json;
      }));
  }

  public async forceArchiveBuildAsync(): Promise<boolean> {
    return (await this.forceArchiveBuild$().toPromise());
  }

  public forceArchiveClean$(): Observable<boolean> {
    const body: any = {
      authenticationUserName: this.configurationService.configAuth.authUserName,
      authenticationPassword: this.configurationService.configAuth.authPassword
    };
    return this.httpPost(this.getUrl('admin/archive/clean'), body)
      .pipe(map((json: boolean) => {
        return json;
      }));
  }

  public async forceArchiveCleanAsync(): Promise<boolean> {
    return (await this.forceArchiveClean$().toPromise())
  }

  public forceTransferToCul$(): Observable<boolean> {
    const body: any = {
      authenticationUserName: this.configurationService.configAuth.authUserName,
      authenticationPassword: this.configurationService.configAuth.authPassword
    };
    return this.httpPost(this.getUrl('admin/cul/transfer'), body)
      .pipe(map((json: boolean) => {
        return json;
      }));
  }

  public async forceTransferToCulAsync(): Promise<boolean> {
    return (await this.forceTransferToCul$().toPromise());
  }

  protected handleHttpError(error: Error): Observable<never> {
    let result: Error = error;
    if (error instanceof TimeoutError) {
      result = new ErrorTimeout();
    } else if (error instanceof HttpErrorResponse) {
      const httpError: HttpErrorResponse = (error as HttpErrorResponse);
      result = new ErrorHttp(httpError.status, httpError.statusText, ((UtilsMisc.isNullOrUndefined(httpError.error) === false) ? httpError.error.errorMessage : httpError.statusText));
      switch (httpError.status) {
        case 0: {
          result.message = 'Es konnte keine Verbindung zum Server aufgebaut werden.';
          break;
        }
        case 403: {
          result.message = 'Keine Berechtigung für Serveraufrufe.';
          break;
        }
      }
    } else {
      result = new ErrorUnknown(error.name, error.message);
    }
    this.loggingService.error(result);
    return throwError(result);
  }

  protected httpPost(url: string, body: any, timeoutInMilliSeconds: number = null, maxRetries: number = null, retryDelay: number = null): Observable<any> {
    if (UtilsMisc.isNullOrUndefined(timeoutInMilliSeconds) === true) {
      timeoutInMilliSeconds = this.configurationService.configData.timeout;
    }
    if (UtilsMisc.isNullOrUndefined(maxRetries) === true) {
      maxRetries = this.configurationService.configData.retries;
    }
    if (UtilsMisc.isNullOrUndefined(retryDelay) === true) {
      retryDelay = this.configurationService.configData.retryDelay;
    }
    return this.http.post(url, body).pipe(
      timeout(timeoutInMilliSeconds),
      catchError(this.handleHttpError.bind(this)),
      retryWithDelay(retryDelay, maxRetries)
    );
  }

  protected getUrl(url: string): string {
    return `/api/cron/${url}`
  }
}
